<template>
  <div>
    <!--    title-->
    <v-row
      style="border-bottom: 1px solid #E5E7EB;"
      class="margin-0"
    >
      <v-col
        class="d-flex justify-start block-title"
      >
        <div
          class="block-title--wrapper"
        >
          {{ item.name || defaultEmptyValue }}
        </div>
      </v-col>
    </v-row>

    <!--    visible data section-->
    <v-row
      v-for="(dataObject, dataObjIndex) in getVisibleItemDetails()"
      :key="dataObjIndex"
      class="margin-0"
    >
      <v-col
        class="data-label"
      >
        {{ dataObject.label }}
      </v-col>

      <v-col
        class="d-flex justify-end data-value"
      >
        {{ dataObject.value }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { dateService, FORMATS } from '@/global/services/date'
const DEFAULT_EMPTY_VALUE = '--'
export default {
  name: 'VehicleServiceHistoryGridBlock',

  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  data () {
    return {
      defaultEmptyValue: DEFAULT_EMPTY_VALUE
    }
  },

  methods: {
    getVisibleItemDetails () {
      return [
        {
          label: this.$t('fleet/vehicle_service.service_type'),
          value: this.item?.type?.description ? this.$t(this.item.type.description) : DEFAULT_EMPTY_VALUE
        },
        {
          label: this.$t('fleet/vehicle_service.archived_state'),
          value: (this.item?.type?.name === 'km' || this.item?.type?.name === 'hours') && this.item?.archived_state
            ? this.item.archived_state + ' ' + this.item.unit
            : dateService.formatFromUtc(this.item.start_state, FORMATS.date)
        },
        {
          label: this.$t('fleet/vehicle_service.archive_service_note'),
          value: this.item?.note || DEFAULT_EMPTY_VALUE
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
.block-title {
  display: flex;
  justify-content: flex-start;
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0;
  color: #111827;
  align-items: center;
  padding-top: 0;
  padding-bottom: 0;
}

.block-title--wrapper {
  display: flex;
  height: 48px;
  align-items: center;
}

.data-label {
  font-family: 'Satoshi', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #6B7280;
}

.data-value {
  font-family: 'Satoshi', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  color: #111827;
  text-align: right;
}

.arrowUpDown {
  position: absolute;
  bottom: 10px;
  left: 50%;
}

.arrowUpDown:hover {
  cursor: pointer;
}
</style>
